<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_bak"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('MerchantNanagement_search_button')"
          @click="funcFilter()"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('MerchantNanagement_add_button')"
          @click="addClick()"
        >
          新增
        </el-button>
        <el-button
          v-if="getLimit('MerchantNanagement_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="szwlCreditStatus"
          :formatter="formatterSzwlCreditMsg"
          title="授信状态"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.szwlCreditStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in szwlCreditStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="partyType"
          :formatter="formatterPartyType"
          title="用户类型"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.partyType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in partyTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="用户姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.name" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="用户手机号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.phone" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="merchantId"
          title="商户ID"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.merchantId"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="merchantName"
          title="商户名称"
          min-width="260"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.merchantName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="merchantType"
          :formatter="formatterStatus"
          title="商户类型"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.merchantType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="alias"
          title="商户简称"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.alias" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          :formatter="formatterStatus2"
          title="商户状态"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="failReason"
          title="失败原因"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.failReason"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="contactName"
          title="联系人姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.contactName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="contactMobile"
          title="联系人手机号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.contactMobile"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderNo"
          title="申请单号"
          min-width="325"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderNo"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          :formatter="formatterKybStatus"
          title="打款验证"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.kybStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in kybStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" width="230">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button
              v-if="
                getLimit('MerchantNanagement_edit_button') &&
                  (scope.row.status != 1 || scope.row.showEdit)
              "
              type="text"
              @click="funcEdit(scope.row.partyCode)"
            >
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="注册商户"
            placement="top"
          >
            <vxe-button
              v-if="
                getLimit('MerchantNanagement_registeredMerchant_button') &&
                  scope.row.status == 0
              "
              type="text"
              @click="registeredMerchant(scope.row.partyCode)"
            >
              <i class="el-icon-upload" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="更新商户注册结果"
            placement="top"
          >
            <vxe-button
              v-if="
                getLimit('MerchantNanagement_updateRegister_button') &&
                  (scope.row.status == 1 || scope.row.status == 3)
              "
              type="text"
              @click="Toupdate(scope.row)"
            >
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="开通余额支付权限"
            placement="top"
          >
            <vxe-button
              v-if="
                getLimit('MerchantNanagement_openBalPay_button') &&
                  scope.row.status == 2 &&
                  scope.row.openBalancePay == 0
              "
              type="text"
              @click="openBalPay(scope.row.partyCode)"
            >
              <i class="el-icon-open" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="开通保证金子户"
            placement="top"
          >
            <vxe-button
              v-if="
                getLimit('MerchantNanagement_openBalPay_button') &&
                  scope.row.status == 2 &&
                  scope.row.openTradeDeposit == 0 &&
                  (scope.row.partyType == 'SHIPMENT' ||
                    scope.row.partyType == 'SHIPMENT_COMPANY')
              "
              type="text"
              @click="openMerchant('TRADE_DEPOSIT', scope.row.partyCode)"
            >
              <i class="el-icon-open" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="查询余额"
            placement="top"
          >
            <vxe-button
              v-if="
                getLimit('MerchantNanagement_checkBalance_button') &&
                  scope.row.status == 2
              "
              type="text"
              @click="CheckBalance(scope.row)"
            >
              <i class="el-icon-search" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="查询钱包信息"
            placement="top"
          >
            <vxe-button
              v-if="
                getLimit('MerchantNanagement_account_button') &&
                  scope.row.openTradeDeposit == 1
              "
              type="text"
              @click="accountClick(scope.row.merchantId)"
            >
              <i class="el-icon-folder-checked" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('MerchantNanagement_merchantEditor_button') &&
                scope.row.merchantType === '03' &&
                scope.row.kybStatus === 0
            "
            class="item"
            effect="dark"
            content="申请验证"
            placement="top"
          >
            <vxe-button
              v-if="scope.row.status == 2"
              type="text"
              @click="MerchantEditor(scope.row.merchantId)"
            >
              <i class="el-icon-circle-check" />
            </vxe-button>
          </el-tooltip>

          <el-tooltip
            v-if="
              getLimit('MerchantNanagement_merchantEditor_button') &&
                scope.row.merchantType === '03' &&
                scope.row.kybStatus === 2
            "
            class="item"
            effect="dark"
            content="验证金额"
            placement="top"
          >
            <vxe-button
              v-if="scope.row.status == 2"
              type="text"
              @click="MerchantEditor(scope.row.merchantId)"
            >
              <i class="el-icon-circle-check" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('MerchantNanagement_openMayiCreditFlow_button') &&
                (scope.row.partyType === 'DRIVER_LEADER' ||
                  scope.row.partyType === 'DRIVER') &&
                (scope.row.szwlCreditStatus === 0 ||
                  scope.row.szwlCreditStatus === 2)
            "
            class="item"
            effect="dark"
            content="申请开通授信"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="openMayiCreditFlow(scope.row.partyCode)"
            >
              <i class="el-icon-thumb" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('MerchantNanagement_refreshMayiCreditFlow_button') &&
                scope.row.szwlCreditStatus === 1 &&
                (scope.row.partyType === 'DRIVER_LEADER' ||
                  scope.row.partyType === 'DRIVER')
            "
            class="item"
            effect="dark"
            content="刷新授信开通结果"
            placement="top"
          >
            <vxe-button
              v-if="scope.row.status == 2"
              type="text"
              @click="refreshMayiCreditFlow(scope.row.partyCode)"
            >
              <i class="el-icon-refresh-right" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="NewlyAdd"
      title="新增"
      width="1000"
      height="800"
      resize
      @close="newAddResetClose"
    >
      <compAdd ref="newAddReset" @event2="receive" />
    </vxe-modal>
    <vxe-modal
      v-model="NewlyEdit"
      title="编辑"
      width="1000"
      height="800"
      resize
    >
      <compEdit ref="EditRef" @event2="receive" />
    </vxe-modal>
    <vxe-modal
      v-model="amountFlag"
      title="验证金额"
      width="350"
      height="200"
      resize
      @close="amountRefClose"
    >
      <compAmount ref="amountRef" :merchant-id="merchantId" @event2="receive" />
    </vxe-modal>
    <vxe-modal
      v-model="newBalance"
      title="余额"
      width="860"
      height="600"
      resize
    >
      <depositModel ref="depositRef" :parent-data="parentData" />
    </vxe-modal>
    <vxe-modal
      v-model="accountinfo"
      title="钱包信息"
      width="400"
      height="220"
      resize
    >
      <div style="padding-left: 30px">
        <p>
          户名：<span>{{ accountinfoDate.bankCertName }}</span>
        </p>
        <P
          >收款银行：<span>{{ accountinfoDate.branchName }}</span></P
        >
        <P
          >收款专用编号：<span>{{ accountinfoDate.bankCardNo }}</span></P
        >
        <p>
          联行号：<span>{{ accountinfoDate.branchNo }}</span>
        </p>
      </div>
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/MerchantManagementAdd.vue";
import compEdit from "./components/MerchantManagementEdit.vue";
import compAmount from "./components/MerchantAmount.vue";
import depositModel from "./components/depositModel.vue";
import request from "@/utils/request";
import {
  MerchantNanagement,
  deleteBankMerchant,
  merchantRegisterResult,
  registerMerchant,
  payApplication,
  mybankKybDetail,
  createAccount,
  accountInfo,
  openBalancePay
} from "@/api/InternetBanking";

export default {
  name: "Parent",
  components: {
    compAdd,
    compEdit,
    compAmount,
    depositModel
  },
  data() {
    return {
      accountinfoDate: {},
      tableData: [],
      balanceList: [],
      exportObj: {
        exportUrl: "/ntocc-tms-api/mybankMerchant/exportMybankMerchantList", //导出接口
        name: "商户管理"
      },
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      merchantId: "",
      acctType: "TRADE_DEPOSIT ",
      newBalance: false,
      //Pagingconf: [],
      NewlyAdd: false,
      NewlyEdit: false,
      amountFlag: false,
      accountinfo: false,
      options: [
        {
          value: "01",
          label: "自然人"
        },
        {
          value: "02",
          label: "个体工商户"
        },
        {
          value: "03",
          label: "企业商户"
        }
      ],
      kybStatusOptions: [
        {
          value: 0,
          label: "待申请"
        },
        {
          value: 1,
          label: "处理中"
        },
        {
          value: 2,
          label: "待验证"
        },
        {
          value: 3,
          label: "已完成"
        },
        {
          value: 4,
          label: "不需要"
        }
      ],
      options2: [
        {
          value: "0",
          label: "待注册"
        },
        {
          value: "1",
          label: "审核中"
        },
        {
          value: "2",
          label: "已注册"
        },
        {
          value: "3",
          label: "待更新"
        },
        {
          value: "4",
          label: "被驳回"
        }
      ],
      parentData: {
        loginCode: this.$store.state.user.party.code,
        partyCode: "",
        partyType: this.$store.state.user.party.partyType
      },
      partyTypeOptions: [
        { label: "平台管理员", value: "PLAT_ADMIN" },
        { label: "车队长", value: "DRIVER_LEADER" },
        { label: "实际承运人", value: "DRIVER" },
        { label: "托运人子账号", value: "SHIPMENT" },
        { label: "托运人", value: "SHIPMENT_COMPANY" }
      ],
      szwlCreditStatusOptions: [
        {
          value: 0,
          label: "未开通"
        },
        {
          value: 1,
          label: "申请中"
        },
        {
          value: 2,
          label: "申请失败"
        },
        {
          value: 3,
          label: "已开通"
        }
      ]
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    }
  },
  created() {
    this.findList();
  },
  methods: {
    async findList() {
      this.loading = true;
      this.tableData = [];
      let response = await MerchantNanagement(this.listQuery);
      this.tableData = response.data.records;
      this.listQuery.total = response.data.total;
      // response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
      // this.listQuery.total = response.data.total;
      this.loading = false;
    },
    Application() {
      payApplication({ merchantId: this.merchantId }).then(response => {
        this.$message({ message: response.msg, type: "success" });
        this.findList();
      });
    },
    // 获取详情
    MerchantEditor(merchantId) {
      this.merchantId = merchantId;
      const rLoading = this.openLoading();
      mybankKybDetail(merchantId).then(response => {
        rLoading.close();
        if (!response.data || response.data.applyStatus == 0) {
          this.Application();
        }
        if (response.data.applyStatus == 1) {
          this.amountFlag = true;
        }
      });
    },
    //删除商户
    funcDelete(a) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteBankMerchant(a).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    //更新商户
    Toupdate(row) {
      const rLoading = this.openLoading();
      merchantRegisterResult(row.partyCode)
        .then(response => {
          rLoading.close();
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        })
        .catch(response => {
          //如果返回异常将编辑按钮展示出来
          this.$set(row, "showEdit", true);
        });
    },
    //开通余额支付权限
    openBalPay(partyCode) {
      openBalancePay(partyCode).then(response => {
        this.$message({ message: response.msg, type: "success" });
        this.findList();
      });
    },
    //开通保证金子户
    openMerchant(acctType, partyCode) {
      createAccount(acctType, partyCode).then(response => {
        this.$message({ message: response.msg, type: "success" });
        this.findList();
      });
    },
    //查询余额
    CheckBalance(a) {
      this.parentData.datas = a;
      this.parentData.partyCode = a.partyCode;
      this.newBalance = true;
      this.$nextTick(function() {
        this.$refs.depositRef.queryBalanceView(a.partyCode);
      });
    },
    //查询钱包
    accountClick(a) {
      this.merchantId = a;
      this.accountinfo = true;
      const rLoading = this.openLoading();
      accountInfo(this.merchantId, this.acctType).then(response => {
        rLoading.close();
        this.accountinfoDate = response.data;
      });
    },
    //注册商户
    registeredMerchant(a) {
      const rLoading = this.openLoading();
      registerMerchant(a)
        .then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        })
        .finally(f => {
          rLoading.close();
        });
    },
    // 申请授信
    openMayiCreditFlow(partyCode) {
      if (partyCode) {
        return request({
          url: "/ntocc-tms-api/maYiCreditFlow/driver/open",
          method: "post",
          params: {
            partyCode: partyCode
          }
        }).then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      } else {
        this.$message({ message: "用户不存在", type: "success" });
      }
    },
    // 刷新授信申请结果
    refreshMayiCreditFlow(partyCode) {
      if (partyCode) {
        return request({
          url: "/ntocc-tms-api/maYiCreditFlow/driver/query",
          method: "post",
          params: {
            partyCode: partyCode
          }
        }).then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      } else {
        this.$message({ message: "用户不存在", type: "success" });
      }
    },
    newAddResetClose() {
      this.$refs.newAddReset.close();
    },
    amountRefClose() {
      this.$refs.amountRef.close();
    },
    //商户类型
    balanceType(type) {
      switch (type) {
        case "BALANCE":
          return "可用余额:";
        case "FREEZE":
          return "冻结余额:";
        case "TRADE_DEPOSIT":
          return "保证金余额:";
        default:
          break;
      }
    },
    //商户类型
    formatterStatus({ cellValue }) {
      switch (cellValue) {
        case "01":
          return "自然人";
        case "02":
          return "个体工商户";
        case "03":
          return "企业商户";
        default:
          break;
      }
    },
    //打款验证状态
    formatterKybStatus({ row }) {
      switch (row.kybStatus) {
        case 0:
          return "待申请";
        case 1:
          return "处理中";
        case 2:
          return "待验证";
        case 3:
          return "已完成";
        case 4:
          return "不需要";
        default:
          return "无状态";
      }
    },
    //商户状态
    formatterStatus2({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "待注册";
        case 1:
          return "审核中";
        case 2:
          return "已注册";
        case 3:
          return "待更新";
        case 4:
          return "被驳回";
        default:
          break;
      }
    },
    formatterPartyType({ cellValue }) {
      const item = this.partyTypeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterSzwlCreditMsg({ cellValue }) {
      const item = this.szwlCreditStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    funcEdit(code) {
      this.$refs.EditRef.MerchantEditor(code);
      this.NewlyEdit = true;
    },
    //新增商户管理
    addClick() {
      this.NewlyAdd = true;
    },
    receive(data) {
      this.findList();
      this.NewlyAdd = false;
      this.NewlyEdit = false;
      this.amountFlag = false;
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>

<style scoped>
/* vxe-modal */
/* ::v-deep .vxe-modal--wrapper.type--modal .vxe-modal--body, .vxe-modal--wrapper.type--modal .vxe-modal--body .vxe-modal--content{
  padding: 0;
} */
</style>
